import React from "react";
import { isVideoPath } from "../../util/utils";

interface MediaThumbProps {
  src?: string;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  onLoad?: (ev: any) => void;
}

export default function MediaThumb({ src, alt = "", className, style, onClick, onLoad }: MediaThumbProps) {
  if (isVideoPath(src)) {
    return <video
      src={`${src}#t=0.1`}
      className={className}
      style={style}
      muted
      playsInline
      preload="metadata"
      onClick={onClick}
      onLoadedData={onLoad}
    />;
  }

  return <img src={src} alt={alt} className={className} style={style} onClick={onClick} onLoad={onLoad} />;
}
